import type { FormColumn, FormField } from '@cli-types/core-engine/schema.js'

export function formColumnTypeForField(field: FormField): FormColumn['type'] | undefined {
  switch (field.type) {
    case 'email':
      return 'email'
    case 'date':
      return 'date'
    case 'number':
      return 'number'
    case 'select':
    case 'radio':
    case 'checkbox':
    case 'multiselect':
      return 'badge'
    case 'text':
    case 'textarea':
    case 'phone':
    case 'url':
    case 'timezone':
      return 'text'
    default:
      return undefined
  }
}
